/* eslint-disable */
/**
 * ⚠️ FROZEN DICTIONARY — 검색어 다국어 → 한국어 별칭 매핑
 * ─────────────────────────────────────────────────────────
 *
 *   📌 절대 임의로 항목을 삭제하지 마세요.
 *   📌 변경 시 반드시 BugHerd 티켓 번호와 함께 PR 작성.
 *   📌 회귀 테스트(__tests__/searchDictionary.test.js) 통과 필수.
 *   📌 CI(.github/workflows/test.yml)가 자동으로 누락 항목을 차단합니다.
 *
 * ─────────────────────────────────────────────────────────
 *
 * 용도:
 *   카카오 Maps 키워드 검색 API 가 한국어 DB 위주이므로
 *   외국어(일/중/영) 입력은 검색 결과 0건으로 돌아옵니다.
 *   본 사전이 외국어 입력을 한국어 검색어로 미리 매핑해서
 *   카카오에 전달 → 정확한 결과 보장.
 *
 * 매핑 정책:
 *   - key: 사용자 입력 (소문자/공백 정리됨, 다국어 가능)
 *   - value: 한국어 검색어 배열 (여러 개면 OR 검색)
 *
 * 클라이언트 컴플레인 이력 (절대 빠뜨리면 안 됨):
 *   #18 (2026-04-29): 일/중/영 입력 시 카카오 검색 결과 0건 — 외국인 사용 불가
 *   #18 코멘트 (2026-05-07): "lotte hotel", "shilla" 등 영문 단독 입력 미동작
 *
 * 변경 시 영향 범위:
 *   - src/api/api/addressSearch.js 가 본 사전을 import 하여 사용
 *   - 모든 transfer 페이지 (공항/골프/스키/병원/반려동물/비즈니스) 검색창
 *
 * ─────────────────────────────────────────────────────────
 */

export const QUERY_ALIASES = {
  // ── 일반 카테고리 (영/일/중) ──
  'hotel': ['호텔'],
  'ホテル': ['호텔'],
  'ホテル ': ['호텔'],
  '酒店': ['호텔'],
  '饭店': ['호텔'],
  'department store': ['신세계백화점', '롯데백화점', '현대백화점'],
  'department': ['백화점'],
  'デパート': ['백화점'],
  '百货店': ['백화점'],
  '百货商店': ['백화점'],
  'duty free': ['신세계면세점', '롯데면세점', '신라면세점'],
  'duty-free': ['신세계면세점', '롯데면세점', '신라면세점'],
  '免税店': ['면세점'],
  '免税': ['면세점'],
  'restaurant': ['식당'],
  'レストラン': ['식당'],
  '餐厅': ['식당'],

  // ── 궁궐 ──
  'palace': ['경복궁', '창덕궁', '덕수궁', '창경궁', '경희궁'],
  'gyeongbokgung': ['경복궁'],
  'changdeokgung': ['창덕궁'],
  'deoksugung': ['덕수궁'],
  '景福宮': ['경복궁'],
  '景福宫': ['경복궁'],
  '景福宮駅': ['경복궁역', '경복궁'],
  '昌德宮': ['창덕궁'],
  '昌德宫': ['창덕궁'],
  '德寿宮': ['덕수궁'],
  '德寿宫': ['덕수궁'],

  // ── 공항 ──
  'airport': ['인천국제공항', '김포국제공항'],
  'incheon airport': ['인천국제공항'],
  'gimpo airport': ['김포국제공항'],
  '空港': ['인천국제공항', '김포국제공항'],
  '机场': ['인천국제공항', '김포국제공항'],
  '仁川空港': ['인천국제공항'],
  '仁川机场': ['인천국제공항'],
  '金浦空港': ['김포국제공항'],
  '金浦机场': ['김포국제공항'],

  // ── 역 ──
  'station': ['서울역', '강남역', '홍대입구역', '명동역'],
  'seoul station': ['서울역'],
  'ソウル駅': ['서울역'],
  '首尔站': ['서울역'],

  // ── 관광지 (영/일/중) ──
  'myeongdong': ['명동'],
  '明洞': ['명동'],
  'ミョンドン': ['명동'],
  'gangnam': ['강남역', '강남'],
  '江南': ['강남'],
  'カンナム': ['강남'],
  'hongdae': ['홍대입구역', '홍대'],
  '弘大': ['홍대', '홍대입구역'],
  'ホンデ': ['홍대'],
  'itaewon': ['이태원'],
  '梨泰院': ['이태원'],
  'イテウォン': ['이태원'],
  'insadong': ['인사동'],
  '仁寺洞': ['인사동'],
  'インサドン': ['인사동'],
  'dongdaemun': ['동대문'],
  '東大門': ['동대문'],
  '东大门': ['동대문'],
  'ドンデムン': ['동대문'],
  'namsan': ['남산', 'N서울타워'],
  '南山': ['남산', 'N서울타워'],
  'ナムサン': ['남산'],
  'n seoul tower': ['N서울타워'],
  'Nソウルタワー': ['N서울타워'],
  '南山首尔塔': ['N서울타워'],
  'lotte tower': ['롯데월드타워'],
  'ロッテタワー': ['롯데월드타워'],
  'lotte world': ['롯데월드'],
  'ロッテワールド': ['롯데월드'],
  '乐天世界': ['롯데월드'],
  'coex': ['코엑스'],
  'COEX': ['코엑스'],
  'コエックス': ['코엑스'],
  'dmz': ['DMZ', '임진각'],
  '광화문': ['광화문'],
  'gwanghwamun': ['광화문'],
  '光化門': ['광화문'],
  '光化门': ['광화문'],
  'bukchon': ['북촌한옥마을'],
  '北村': ['북촌한옥마을'],
  '北村韓屋村': ['북촌한옥마을'],
  'hanok village': ['북촌한옥마을', '남산한옥마을'],
  '韓屋村': ['북촌한옥마을', '남산한옥마을'],

  // ── 한국 주요 브랜드 영문 입력 → 한글 변환 (BugHerd #18 2026-05-07 코멘트) ──
  // 단독 영문 입력 시 DeepL hallucinate 방지를 위해 정적 사전에 고정.
  'lotte': ['롯데'],
  'lotte hotel': ['롯데호텔'],
  'lotte mart': ['롯데마트'],
  'lotte department': ['롯데백화점'],
  'lotte department store': ['롯데백화점'],
  'lotte duty free': ['롯데면세점'],
  'shilla': ['신라'],
  'shilla hotel': ['신라호텔'],
  'shilla duty free': ['신라면세점'],
  'shinsegae': ['신세계'],
  'shinsegae department': ['신세계백화점'],
  'shinsegae department store': ['신세계백화점'],
  'shinsegae duty free': ['신세계면세점'],
  'hyundai department': ['현대백화점'],
  'hyundai department store': ['현대백화점'],
  'galleria': ['갤러리아백화점'],
};

/**
 * 검색어 별칭 매칭 — 케이스 무시, 공백 정리.
 * @param {string} q 사용자 입력
 * @returns {string[] | null} 한국어 검색어 배열, 매칭 없으면 null
 */
export function getQueryAliases(q) {
  if (!q) return null;
  const normalized = q.toLowerCase().trim().replace(/\s+/g, ' ');
  return QUERY_ALIASES[normalized] || null;
}
